// #1079 <form data-diff-submit> の送信時、初期値から変更されていない入力を disabled にして
// 差分のフィールドだけを送る(disabled な要素はフォーム送信に含まれない)。
//
// - 必須チェックはブラウザ標準の検証(reportValidity)を通した後に行う
// - hidden / submit / CSRFトークン等は常に送る
// - Railsのマルチパラメータ属性(birthday_on(1i)/(2i)/(3i))は1つでも変われば3つとも送る
// - <input type="file"> はファイルが選ばれていない時だけ除外する
// - 送信がキャンセルされた場合(検証エラー等)に元に戻せるよう、disabled にした要素は記録しておく

const ALWAYS_SEND = new Set(['_method', 'authenticity_token', 'utf8', 'context'])
const MULTIPARAM_RE = /^(.*)\(\d+[if]?\)$/

function isChanged(el) {
  switch (el.tagName) {
    case 'SELECT': {
      if (el.multiple) return Array.from(el.options).some((opt) => opt.selected !== opt.defaultSelected)
      // 現在値が空(include_blank)だと selected 属性を持つ option が無く、ブラウザは先頭を選ぶ。
      // その場合は先頭 option が「初期値」なので、それと比較する。
      const defaultIndex = Array.from(el.options).findIndex((opt) => opt.defaultSelected)
      return el.selectedIndex !== (defaultIndex === -1 ? 0 : defaultIndex)
    }
    case 'TEXTAREA':
      return el.value !== el.defaultValue
    case 'INPUT':
      if (el.type === 'checkbox' || el.type === 'radio') return el.checked !== el.defaultChecked
      if (el.type === 'file') return el.files && el.files.length > 0
      return el.value !== el.defaultValue
    default:
      return true
  }
}

function groupKey(name) {
  const m = name.match(MULTIPARAM_RE)
  return m ? m[1] : name
}

function handleSubmit(event) {
  const form = event.currentTarget
  if (typeof form.reportValidity === 'function' && !form.reportValidity()) {
    event.preventDefault()
    return
  }

  const candidates = Array.from(form.elements).filter((el) => {
    if (!el.name || el.disabled) return false
    if (el.type === 'hidden' || el.type === 'submit' || el.type === 'button') return false
    if (ALWAYS_SEND.has(el.name)) return false
    return true
  })

  // グループ(マルチパラメータ)単位で変更有無を判定
  const changedGroups = new Set()
  candidates.forEach((el) => {
    if (isChanged(el)) changedGroups.add(groupKey(el.name))
  })

  const disabled = []
  candidates.forEach((el) => {
    if (!changedGroups.has(groupKey(el.name))) {
      el.disabled = true
      disabled.push(el)
    }
  })

  // ページ遷移せず戻ってきた場合(送信中止など)に入力可能状態へ復帰させる
  setTimeout(() => disabled.forEach((el) => { el.disabled = false }), 1500)
}

export function initDiffSubmit(root = document) {
  root.querySelectorAll('form[data-diff-submit]').forEach((form) => {
    if (form.dataset.diffSubmitBound) return
    form.addEventListener('submit', handleSubmit)
    form.dataset.diffSubmitBound = 'true'
  })
}
